import styled from 'styled-components';
import { Toggle } from 'ui/toggle';
import { Tooltip } from 'ui/tooltip';
import { body2, colors, shadows, spacing } from 'ui/theme';

export type StyledButtonWithToggleProps = {
  isToggleActive?: boolean;
};

export const StyledButtonWithToggle = styled.div<StyledButtonWithToggleProps>`
  border: 1px solid ${(props) => (props.isToggleActive ? colors.green50 : colors.grey15)};
  padding: ${spacing.half} ${spacing.threeQuarter};
  box-shadow: ${(props) =>
    props.isToggleActive ? `0px 0px 4px rgba(89, 193, 167, 0.7)` : shadows.small};
  border-radius: ${spacing.quarter};
  display: flex;
  align-items: center;
`;

export const StyledToggle = styled(Toggle)`
  padding-left: ${spacing.threeQuarter};
`;

export const CopyAssistMenuWrapper = styled.div`
  padding: ${spacing.quarter} ${spacing.half};
`;

export const CopyAssistMenuItemEnabled = styled.div<{ isLoading: boolean }>`
  ${body2}
  color: ${(props) => (props.isLoading ? colors.textDisabled : colors.textLink)};
  padding: ${spacing.quarter} ${spacing.half};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};

  svg {
    margin-bottom: ${spacing.eighth};
  }

  &:hover {
    cursor: pointer;
    background-color: ${colors.grey1};

    svg {
      transform: rotate(20deg);
      transition: transform 0.5s ease;
    }
  }
`;

export const CopyAssistMenuItemDisabledTooltip = styled(Tooltip)`
  ${body2}
  color: ${colors.textDisabled};
  padding: ${spacing.quarter} ${spacing.half};
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: not-allowed;
`;

export const CopyAssistMenuItemDisabled = styled.div`
  display: flex;
  gap: ${spacing.half};
  svg {
    margin-bottom: ${spacing.eighth};
  }
`;
